module.exports = __webpack_public_path__ + "img/yaoshi_gaoji.e23cb33c.png";